import { lazyLoadView } from '@router/helpers';

export default [
  {
    path: '/:operator/:id(\\d+)/loket',
    name: 'loket',
    component: () => lazyLoadView(import('@views/admin/loket/List.vue')),
    meta: {
      title: 'Loket',
    },
  },
  {
    path: '/:operator/:id(\\d+)/loket/:loket_id(\\d+)',
    name: 'loket-detil',
    component: () => lazyLoadView(import('@views/admin/loket/Detail.vue')),
    meta: {
      title: 'Profil Loket',
    },
  },
];
